import { Cake, Users, Briefcase, PartyPopper, Utensils, Sparkles } from "lucide-react";
import { mogelijkheden } from "../../data/content";

const icons = [Cake, Users, Briefcase, PartyPopper, Utensils, Sparkles];

export const Mogelijkheden = () => {
  return (
    <section id="mogelijkheden" data-testid="mogelijkheden-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-primary font-semibold text-sm uppercase tracking-wide">Mogelijkheden</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mt-3">
            Waarvoor kun je hier terecht?
          </h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
            Van een verjaardag tot een bedrijfsuitje. Bij De Proatkoele is er ruimte voor allerlei bijeenkomsten.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mogelijkheden.map((m, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div
                key={m.titel}
                data-testid={`mogelijkheid-${i}`}
                className="bg-card border border-border rounded-2xl p-7 hover:border-primary/40 transition-colors"
              >
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                  <Icon size={22} className="text-primary" />
                </div>
                <h3 className="font-heading text-lg font-semibold">{m.titel}</h3>
                <p className="mt-2 text-muted-foreground leading-relaxed">{m.tekst}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
